var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.$t('text.noParentConsent')))]),_c('v-btn',{attrs:{"color":"primary ma-1","href":"/logout"}},[_vm._v(_vm._s(_vm.$t('button.logout')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }